import { writable, get } from "svelte/store";
import * as api from "../utiles/api.js";
import toast from "svelte-french-toast";

export { retechInfo, retech_jwt_token, retech_refresh_token } from "./authStore.js";

const getFormattedDate = (date) => date.toISOString().split('T')[0];
const today = new Date();
const threeMonthsAgo = new Date();
threeMonthsAgo.setMonth(today.getMonth() - 3);

export const shipmentStore = writable({
    list: [],
    selectedItem: null,
    details: [],
    scrollPos: 0,
    detailScrollPos: 0,
    isSearchLoading: false,
    isDetailLoading: false,
    search: {
        isExpanded: true,
        shipType: '전체',
        salesGroup: '',
        startDate: '2025-01-01',
        endDate: '2026-12-31',
        customer: '',
        orderNo: '',
        requestNo: '',
        includeComplete: false,
        includeClose: false
    }
});

export async function fetchShipmentData(bplc_code, silent = false) {
    const store = get(shipmentStore);
    try {
        shipmentStore.update((s) => ({ ...s, isSearchLoading: true }));
        const searchParams = new URLSearchParams({
            as_bplc_code: bplc_code || "01",
            as_shipmnt_ty_code: store.search.shipType === "전체" ? "" : store.search.shipType,
            as_shipmnt_ty_nm: "",
            as_bsn_group_code: store.search.salesGroup || "",
            as_bsn_group_nm: "",
            ad_dlivy_sde: store.search.startDate || "",
            ad_dlivy_ede: store.search.endDate || "",
            as_bc_nm: store.search.customer || "",
            as_bcnc_nm: store.search.customer || "",
            as_shipmnt_bcnc_code: "", // 💡 검색 시 코드는 명시적으로 비움 (이름 검색 우선)
            as_rcvord_no: store.search.orderNo || "",
            as_request_no: store.search.requestNo || "",
            as_requst_no: store.search.requestNo || "",
            as_shipmnt_at: store.search.includeComplete ? "%" : "N",
            as_clos_at: store.search.includeClose ? "%" : "N",
        });

        const response = await api.get(`/shipment?${searchParams.toString()}`);

        if (response && response.data) {
            shipmentStore.update((s) => ({
                ...s,
                list: response.data,
                selectedItem: null,
                details: [],
            }));
            if (!silent) toast.success("출하 조회 완료");
        }
    } catch (err) {
        console.error(err);
        if (!silent) toast.error("출하 조회 중 오류가 발생했습니다.");
    } finally {
        shipmentStore.update((s) => ({ ...s, isSearchLoading: false }));
    }
}